module.exports = __webpack_public_path__ + "img/vectro.a0b101df.svg";